<template>
    <div class="accordion--card">
        <button
            :class="accordionStyle"
            data-toggle="collapse"
            :data-target="`#${accordionCardId}`"
            aria-expanded="false"
            :aria-controls="accordionCardId"
        >
            {{ accordionCardTitle}}
        </button>
        <div :id="accordionCardId" class="collapse show" aria-labelledby="headingTwo" >
            <div class="mt-3" >
                <a
                    v-for="(status, index) in listOfItems"
                    :key="status.id"
                    :class="{ 'status-row-selected': activeStatusTab === status }"
                    @click="$emit('change-tab', status)"
                    class="status-row"
                >
                    <div class="d-flex">
                        <div><b>{{ setItemNumber(index) }}</b></div>
                        <div v-if="type === 'terminate'">
                            {{setStageTitle(status.action)}}
                        </div>
                        <div v-else>
                            {{ status.template.name }}
                        </div>
                    </div>
                    <div class="color--text-gray small-text" v-if="status.isComplete">
                        {{calculateDate(status.complete_date ?? status.created_at)}}
                    </div>
                    <div class="color--text-gray small-text" v-if="type === 'terminate'">
                        {{calculateDate(status.created_at)}}
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import DateConverter from "../../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'ApplicantStageSelector',
    mixins: [DateConverter,],
    props: {
        accordionCardId: String,
        accordionStyle: String,
        accordionCardTitle: String,
        listOfItems: Array,
        activeStatusTab: Object,
        type: String,
        pendingLength: Number,
        activeLength: Number,
    },

    methods: {
        setItemNumber(index) {
            if (this.type === 'pending') {
                return index + 1
            } else if (this.type === 'active') {
                return index + 1 + this.pendingLength
            } else {
                return this.pendingLength + this.activeLength + 1 + index
            }
        },
        setStageTitle(action) {
            if (action === 'deactivate') {
                return 'Deactivation'
            } else {
                return 'Reactivation'
            }
        },
    }
}

</script>



<style scoped>

</style>
